import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  BsBarChartLine,
  BsBell,
  BsBoxArrowRight,
  BsBoxSeam,
  BsChatDots,
  BsChevronLeft,
  BsChevronRight,
  BsCpu,
  BsGear,
  BsGlobe2,
  BsHeadset,
  BsHouseDoor,
  BsLink45Deg,
  BsRobot,
  BsX,
} from 'react-icons/bs';
import './Sidebar.css';
import api from '../lib/api';

const menuItems = [
  { to: '/admin', label: 'Dashboard', icon: BsHouseDoor },
  { to: '/chatlogs', label: 'Chat Logs', icon: BsChatDots },
  { to: '/stats', label: 'Analytics', icon: BsBarChartLine },
  { to: '/instruct', label: 'Instruct AI', icon: BsCpu },
  { to: '/branding', label: 'Brand Router', icon: BsLink45Deg },
  { to: '/widgets', label: 'Widgets', icon: BsBoxSeam },
  { to: '/admin/training', label: 'Training', icon: BsGlobe2 },
  { to: '/admin/settings', label: 'Settings', icon: BsGear },
  { to: '/admin/landing', label: 'Landing Builder', icon: BsRobot },
  { to: '/admin/agent-inbox', label: 'Agent Inbox', icon: BsHeadset },
  { to: '/admin/agent-analytics', label: 'Agent Analytics', icon: BsBarChartLine },
  { to: '/admin/notifications', label: 'Notifications', icon: BsBell },
];

const Sidebar = ({ collapsed, setCollapsed, mobileSidebarOpen, setMobileSidebarOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [handoverUnread, setHandoverUnread] = useState(0);

  useEffect(() => {
    let mounted = true;

    const loadUnread = async () => {
      try {
        const { data } = await api.get('/handover/notifications/unread-count/', {
          suppressToast: true,
        });

        if (mounted) {
          setHandoverUnread(Number(data?.unread_count || 0));
        }
      } catch {
        if (mounted) {
          setHandoverUnread(0);
        }
      }
    };

    loadUnread();
    const timer = setInterval(loadUnread, 15000);

    return () => {
      mounted = false;
      clearInterval(timer);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    localStorage.removeItem('admin_pin_ok');
    navigate('/admin/login');
  };

  return (
    <aside className={`admin-sidebar ${collapsed ? 'collapsed' : ''} ${mobileSidebarOpen ? 'mobile-open' : ''}`}>
      <div className="admin-sidebar__header">
        <div className="admin-sidebar__brand">
          {!collapsed && (
            <div>
              <h6 className="mb-0 fw-bold text-white">AI Admin</h6>
              <small className="text-white-50">Control Panel</small>
            </div>
          )}
        </div>

        <button
          type="button"
          className="admin-sidebar__toggle d-none d-lg-grid"
          onClick={() => setCollapsed(!collapsed)}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {collapsed ? <BsChevronRight /> : <BsChevronLeft />}
        </button>

        <button
          type="button"
          className="admin-sidebar__toggle d-grid d-lg-none"
          onClick={() => setMobileSidebarOpen(false)}
          aria-label="Close sidebar"
        >
          <BsX />
        </button>
      </div>

      <div className="admin-sidebar__menu">
        <Nav className="flex-column gap-1">
          {menuItems.map((item) => {
            const Icon = item.icon;

            const active =
              location.pathname === item.to ||
              (item.to !== '/admin' && location.pathname.startsWith(item.to));

            const showUnread =
              item.to === '/admin/agent-inbox' ||
              item.to === '/admin/notifications';

            return (
              <Nav.Item key={item.to}>
                <Link
                  to={item.to}
                  className={`admin-sidebar__link ${active ? 'active' : ''}`}
                  onClick={() => setMobileSidebarOpen(false)}
                >
                  <span className="admin-sidebar__icon">
                    <Icon />
                  </span>

                  {!collapsed && (
                    <span className="d-flex align-items-center gap-2">
                      <span>{item.label}</span>
                      {showUnread && handoverUnread > 0 ? (
                        <span className="badge rounded-pill bg-danger">
                          {handoverUnread}
                        </span>
                      ) : null}
                    </span>
                  )}
                </Link>
              </Nav.Item>
            );
          })}
        </Nav>
      </div>

      <div className="admin-sidebar__footer">
        <button
          type="button"
          className="admin-sidebar__logout"
          onClick={handleLogout}
        >
          <span className="admin-sidebar__icon">
            <BsBoxArrowRight />
          </span>
          {!collapsed && <span>Logout</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;